import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  getAutomationCurrentConnector,
  getIsLoadingDetail
} from '../store/selectors/rpa-automation-anywhere-conn.selector';
import { UpdateAutomationAnywhereConn, TestAutomationAnywhereConn } from '../store/actions/rpa-automation-anywhere-conn.actions';
import { BotConfigurationComponent } from '../../shared/bot-configuration/bot-configuration.component';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import {RpaBotsService} from '../../core/rpa-bots.service';
import { BzgModalService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmModalComponent } from 'app/rpa-bots/uipath/common-components/confirm-modal/confirm-modal.component';
import { IAppState } from 'app/IAppState';
import { IRPAWrapperDetails, IRpaConnectionAutomationAnywhere } from 'app/rpa-bots/core/IRpaBots';

@Component({
  selector: 'automation-detail-wrapper',
  templateUrl: 'automation-detail-wrapper.component.html',
  styleUrls: ['automation-detail-wrapper.component.scss']
})
export class AutomationDetailWrapperComponent implements IRPAWrapperDetails {
  @ViewChild('botConfiguration', { static: false}) botConfiguration: BotConfigurationComponent;

  public automationConnection$: Observable<IRpaConnectionAutomationAnywhere>;
  public isLoading$: Observable<boolean>;
  @ViewChild('botConfiguration', { static: false})
  private _botConfigurationComponent: BotConfigurationComponent;
  @Input() pendingChangesFunction: Function;
  change_dataConfigurationTitle:string;
  change_dataConfigurationMessage:string;

  constructor(private _store: Store<IAppState>,
              private _rpaBotsService: RpaBotsService, private _modalService: BzgModalService, private translate: TranslateService) {
    this.automationConnection$ = this._store.pipe(
      select(getAutomationCurrentConnector)
    );
    this.isLoading$ = this._store.pipe(select(getIsLoadingDetail));
  }

  ngOnInit() {
    this.translate.get('RPA_BOTS.CONFIRMATION').subscribe(translation => {
      this.change_dataConfigurationTitle = translation;
  });
  this.translate.get('RPA_BOTS.CHANGE_DATA_CONFIGURACION').subscribe(translation => {
      this.change_dataConfigurationMessage = translation;
  });
  }

  onTestConnection(bot: IRpaConnectionAutomationAnywhere) {
    this._store.dispatch(new TestAutomationAnywhereConn(bot));
  }

  onSave(bot: IRpaConnectionAutomationAnywhere) {
    this.showConfirmDialog(() => { this._store.dispatch(new UpdateAutomationAnywhereConn(bot)) })
  }


  get isConnectorValid(): boolean {
    return this._botConfigurationComponent ? this._botConfigurationComponent.isValid() : false;
  }

  get hasPendingChanges(): boolean {
    return this._botConfigurationComponent ? this._botConfigurationComponent.hasChanges : false;
  }

  get modifiedConnector(): RpaConnectorDetail {
    return this._botConfigurationComponent ? this._botConfigurationComponent.botDetail : null;
  }

  public showConfirmDialog(callback) {
    const deleteModal = this._modalService.open(ConfirmModalComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: {
            title: this.change_dataConfigurationTitle,
            message: this.change_dataConfigurationMessage,
            button: "OK"
        }
    });
    deleteModal.afterClosed().subscribe((result: string) => {
        if (result === 'ok') {
            callback();
        }
    })
}
}
